import React, { createContext, useRef, useState } from "react";
import videoData from "@data/videoData.js";

const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
  const [uuid, setUuid] = useState(null);
  const headerRef = useRef(null);
  const stickyIsiRef = useRef(null);
  const isiRef = useRef(null);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [showExitModal, setShowExitModal] = useState(false);
  const [exitUrl, setExitUrl] = useState("");
  const [exitIsThirdParty, setExitIsThirdParty] = useState(false);
  const [showPatientAuthModal, setShowPatientAuthModal] = useState(false);
  const [showVideoISIModal, setShowVideoISIModal] = useState(false);
  const [videoISIViewed, setVideoISIViewed] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [currentVideo, setCurrentVideo] = useState({
    videoUrl: "",
    transcriptPath: "",
    videoPlaceholder: null,
  });
  const videoISIContinueCallback = useRef(null);
  const [mobileFASTPDropdownOpen, setMobileFASTPDropdownOpen] = useState(false);

  // Exit Modal
  const openExitModal = (url) => {
    setExitUrl(url);
    setShowExitModal(true);
  };

  const closeExitModal = () => {
    setShowExitModal(false);

    // bug fix: prevent the modal from closing before the exit URL is opened
    // without this, the exit url clears too fast, and the browser opens a tab with the same url instead of the exit one
    setTimeout(() => {
      setExitUrl("");
    }, 100);
  };

  const openPatientAuthModal = () => {
    setShowPatientAuthModal(true);
  };

  const closePatientAuthModal = () => {
    setShowPatientAuthModal(false);
  };

  const openVideoISIModal = () => {
    setShowVideoISIModal(true);
  };

  const closeVideoISIModal = () => {
    setShowVideoISIModal(false);
  };

  const openVideoModal = () => {
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
  };

  const updateCurrentVideo = (videoData) => {
    setCurrentVideo(videoData);
  };

  const toggleMobileFASTPDropdown = () => {
    setMobileFASTPDropdownOpen((mobileFASTPDropdownOpen) => !mobileFASTPDropdownOpen);
  };

  const store = {
    uuid,
    setUuid,
    headerRef,
    stickyIsiRef,
    isiRef,
    isHeaderVisible,
    setIsHeaderVisible,
    showExitModal,
    exitUrl,
    openExitModal,
    closeExitModal,
    exitIsThirdParty,
    setExitIsThirdParty,
    showPatientAuthModal,
    openPatientAuthModal,
    closePatientAuthModal,
    showVideoISIModal,
    openVideoISIModal,
    closeVideoISIModal,
    videoISIViewed,
    setVideoISIViewed,
    showVideoModal,
    openVideoModal,
    closeVideoModal,
    currentVideo,
    updateCurrentVideo,
    videoISIContinueCallback,
    mobileFASTPDropdownOpen,
    setMobileFASTPDropdownOpen,
    toggleMobileFASTPDropdown,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
